import { TaggedValue } from '../core';

export type Integer = TaggedValue<'Integer', number>;

export type IntegerInput = number | bigint;

export const $Integer = {
  from(c: IntegerInput): Integer {
    switch (typeof c) {
      case 'bigint':
        return Number(c) as Integer;
    }

    return Number(BigInt(c)) as Integer;
  },
};
